import React from "react"
import {Container} from "reactstrap"


const Footer = () => {
    return (
        <Container fluid tag="footer" className="bg-info text-center text-warning fixed-bottom ">
        Quizzy@ Copywrights
        </Container>
    )
}

export default Footer;